<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="page-login">
    <div class="login-container">
      
      <div class="login-top">
        <img src="../../../public/img/TurkishRestaurantLogo.png" />
      </div>
      <div class="login-mid logout">
        <i class="far fa-check-circle"></i>
      <h2>Logout Successful</h2>
      <p>Redirecting...</p>
    </div>
    </div>
  </div>
</template>

<script>
export default{
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {

    this.$store.commit('api/SET_TOKEN_VALID', false)

    localStorage.clear()
    const self = this
    setTimeout(function () {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      self.$router.push('/').catch(() => {})
    }, 500)
  }
}
</script>

<style lang="scss">
#page-login {
  .login-header {
    text-align: center;
    padding: 1rem;
    justify-content: center;
  }
  .vx-card {
    overflow:hidden;
  }
  .vx-logo-text {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
}
</style>
